<script setup>
import model from "@js/model.js";
import { ref } from "vue";
import vUrlIframe from "@directives/url-iframe.js";
import { addQueryStringValues } from "@helpers/utils.js";

const props = defineProps(['path']);

const url = addQueryStringValues(model.urls.dynamicNotifications + props.path, {c: Date.now()});
const reloadBtnDisplayed = location.host.includes('localhost');

const loaded = ref(false);

const vDynamicNotification = {
    mounted(element){
        let iframe = element.querySelector('iframe');

        let reloadBtn = element.querySelector('.reload-btn');
        if(reloadBtn) element.addEventListener('click', () => iframe.src = url);

        let closeBtn = element.querySelector('.close');

        element.postMessageCallback = model.on('PostMessageReceived', e => {
            let data = e.event.data;

            switch(data.type){
                case 'DynamicPopupLoadSuccess' : 
                loaded.value = true;
                break;
                case 'DynamicPopupCloseBtnLocation' : 
                if(model.vue.root.mobileMode){
                    closeBtn.style.top = null;
                    closeBtn.style.left = null;
                }
                else{
                    let top = data.value.y - closeBtn.offsetHeight - 5;
                    let left = data.value.x - closeBtn.offsetWidth;

                    if(top < 10) top = 10;

                    closeBtn.style.top = top + 'px';
                    closeBtn.style.left = left + 'px';
                }
                break;
            }
        });
    },
    unmounted(element){
        model.off('PostMessageReceived', element.postMessageCallback);
    },
}

function onClose(){
    model.observables.dynamicNotification = null;
}
</script>

<template>
    <template v-if="!model.observables.modals.length">
        <div id="dynamic-notification" v-dynamic-notification>
            <template v-if="reloadBtnDisplayed">
                <div class="reload-btn">RELOAD</div>
            </template>
            <iframe v-url-iframe="{url}"></iframe>
            <div class="close" @click.prevent.stop="onClose()">&times;</div>
            <template v-if="!loaded">
                <div class="preloader-container">
                    <preload-icon></preload-icon>
                </div>
            </template>
        </div>
    </template>
</template>

<style lang="scss">
@import "@css/var-config";
@import "@css/shared-mixins";

$site-key: "fund";

#dynamic-notification{
    position: fixed;
    top: 0;
    left: 0;
    width: 100dvw;
    height: 100dvh;
    z-index: 2000;
    & > iframe,
    & > .preloader-container{
        width: inherit;
        height: inherit;
        border: none;
    }
    & > .preloader-container{
        position: absolute;
        top:0;
        left:0;
    }
    & > .reload-btn{
        position: absolute;
        left: 40px;
        bottom: 20px;
        background-color: #fff;
        color: #000;
        padding: 10px 20px;
        cursor: pointer;
        border: 2px solid #000;
    }
    & > .close{
        @include fund-prompt-close(15px, 15px);
    }
}
</style>